export default __webpack_public_path__ + "static/media/no-mistakes-illustration-blob-top.4fb915f6.svg";